/**
 * @file
 *
 * This file describes the 'Reducer' mapping, is also a good point to define 'Epic' functions.
 * Note that an Action always run first through the reducer before the Epic even receive it.
 * @author JPablo
 */
import {AnyAction} from "redux";
import "rxjs/operators/delay";
import * as moment from "moment";
import {authenticatedAjax, REQUEST} from "../../../config/ajax-wrapper";
import {
    ACTUALIZAR_TIPO_DOCUMENTAL,
    AFILIACION_CONSULTADA,
    afiliacionConsultada,
    ANULAR_DOCUMENTOS,
    APROBAR_DOCUMENTOS,
    APROBAR_DOCUMENTOS_COMERCIAL,
    CONSULTAR_AFILIACION,
    CONSULTAR_DOCUMENTO_P8,
    CONSULTAR_DOCUMENTOS,
    CONSULTAR_DOCUMENTOS_COMERCIAL,
    CONSULTAR_MOTIVOS_RECHAZO,
    DOCUMENTO_P8_CONSULTADO,
    documentoP8Consultado,
    DOCUMENTOS_ANULADOS,
    DOCUMENTOS_APROBADOS,
    DOCUMENTOS_COMERCIAL_APROBADOS,
    DOCUMENTOS_COMERCIAL_REPORTADOS,
    DOCUMENTOS_CONSULTADOS,
    DOCUMENTOS_CONSULTADOS_COMERCIAL,
    DOCUMENTOS_RECHAZADOS,
    DOCUMENTOS_RECIBIDOS,
    documentosAnulados,
    documentosAprobados,
    documentosComercialAprobados,
    documentosComercialReportados,
    documentosConsultados,
    documentosConsultadosComercial,
    documentosRechazados,
    documentosRecibidos,
    ERROR_ACTUALIZANDO_TIPO_DOCUMENTAL,
    ERROR_ANULANDO_DOCUMENTOS,
    ERROR_APROBANDO_DOCUMENTOS,
    ERROR_APROBANDO_DOCUMENTOS_COMERCIAL,
    ERROR_CONSULTANDO_AFILIACION,
    ERROR_CONSULTANDO_DOCUMENTO_P8,
    ERROR_CONSULTANDO_DOCUMENTOS,
    ERROR_CONSULTANDO_DOCUMENTOS_COMERCIAL,
    ERROR_RECHAZANDO_DOCUMENTOS,
    ERROR_REPORTANDO_DOCUMENTOS_COMERCIAL,
    ERROR_RECIBIENDO_DOCUMENTOS,
    errorActualizandoTipoDocumental,
    errorAnulandoDocumentos,
    errorAprobandoDocumentos,
    errorAprobandoDocumentosComercial,
    errorConsultandoAfiliacion,
    errorConsultandoDocumentoP8,
    errorConsultandoDocumentos,
    errorConsultandoDocumentosComercial,
    errorConsultandoMotivosRechazo,
    errorRechazandoDocumentos,
    errorRecibiendoDocumentos,
    errorReportandoDocumentosComercial,
    LIMPIAR_MENSAJES_DOCUMENTOS,
    MOTIVOS_RECHAZO_CONSULTADOS,
    motivosRechazoConsultados,
    RECHAZAR_DOCUMENTOS,
    RECIBIR_DOCUMENTOS,
    REPORTAR_DOCUMENTOS_COMERCIAL,
    TIPO_DOCUMENTAL_ACTUALIZADO,
    tipoDocumentalActualizado,
    VALIDAR_ASIGNACION,
    VALIDACION_FINALIZADA,
    validacionFinalizada
} from "./documentosActions";
import {Afiliacion, Documento, MotivoRechazo} from "../modelo/Documento";
import {DATE_FORMAT_WITH_HOUR} from "../../general/componentes/DatePicker";
import {obtenerTipoCliente} from "../modelo/TiposCliente";
import {EstadoDocumento} from "../modelo/EstadosDocumento";
import {DocumentoP8} from "../modelo/DocumentoP8";

/*
* Epics
* https://redux-observable.js.org/docs/basics/Epics.html
*/
export const consultarDocumentosEpic = action$ =>
    action$.ofType(CONSULTAR_DOCUMENTOS)
        .mergeMap((action) => {
            var filter = action.filtroDocumento && action.filtroDocumento.dni ? `dni=${action.filtroDocumento.dni}` : "";
            filter += action.filtroDocumento && action.filtroDocumento.fechaInicio ?
            (filter ? `&fechaInicio=${action.filtroDocumento.fechaInicio}` :
                    `fechaInicio=${action.filtroDocumento.fechaInicio}`)
                : ""; 

            filter += action.filtroDocumento && action.filtroDocumento.fechaFin ?
                (filter ? `&fechaFin=${action.filtroDocumento.fechaFin}` :
                        `fechaFin=${action.filtroDocumento.fechaFin}`)
                    : ""; 

            filter += action.filtroDocumento && action.filtroDocumento.tipoCliente ? 
                (filter ? `&tipoCliente=${action.filtroDocumento.tipoCliente}` :
                        `tipoCliente=${action.filtroDocumento.tipoCliente}`)
                    : "";
            
            filter += action.filtroDocumento.tamanoPagina ?
                (filter ? `&registrosPorPagina=${action.filtroDocumento.tamanoPagina}` :
                    `registrosPorPagina=${action.filtroDocumento.tamanoPagina}`)
                : "";

            filter += action.filtroDocumento.paginaActual ?
                (filter ? `&pagina=${(action.filtroDocumento.paginaActual + 1)}` :
                    `pagina=${(action.filtroDocumento.paginaActual + 1)}`)
                : "";

            filter += action.filtroDocumento.tipoTramite ?
                (filter ? `&tipoTramite=${(action.filtroDocumento.tipoTramite)}` :
                    `tipoTramite=${(action.filtroDocumento.tipoTramite)}`)
                : "";

            filter += action.filtroDocumento.canalComercial ?
                (filter ? `&canalComercial=${(action.filtroDocumento.canalComercial)}` :
                    `canalComercial=${(action.filtroDocumento.canalComercial)}`)
                : "";

            const url = `documentos?${filter}`;

            return authenticatedAjax
                .get(
                    url
                )
                .map((response) => {
                    const respuesta = JSON.parse(response.response);
                    return documentosConsultados(parseDocumentos(respuesta.respuesta),respuesta.paginas);
                })
                .catch(error => {
                    return [errorConsultandoDocumentos()];
                }
                );
        });


export const consultarDocumentoP8Epic = action$ =>
    action$.ofType(CONSULTAR_DOCUMENTO_P8)
        .mergeMap((action) => {

            const url = `documento/${action.idDocumento}`;

            return authenticatedAjax
                .get(url)
                .map((response) =>
                    documentoP8Consultado(JSON.parse(response.response))
                )
                .catch(response =>
                    [errorConsultandoDocumentoP8()]
                );
        });


export const validarAsignacionEpic = action$ =>
        action$.ofType(VALIDAR_ASIGNACION)
            .mergeMap((action) => {
                console.log("action",action);
                const url = `procesar-asignacion?dni=${action.dni}&tipoCliente=${action.tipoCliente}`;
                return authenticatedAjax
                    .get(url)
                    .map((response) => {
                        const respuesta = JSON.parse(response.response);
                        return validacionFinalizada(action.dni, respuesta.asignado, respuesta.nombreAsesor,action.tipoCliente);
                    }
                    
                    )
                    .catch(response =>
                        [errorConsultandoDocumentoP8()]
                    );
            });

export const consultarMotivosRechazoEpic = action$ =>
    action$.ofType(CONSULTAR_MOTIVOS_RECHAZO)
        .mergeMap((action) => {
            return authenticatedAjax
                .get("motivos-rechazo")
                .map((response) =>
                    motivosRechazoConsultados(
                        parseMotivosRechazo(JSON.parse(response.response))
                    )
                )
                .catch(response =>
                    [errorConsultandoMotivosRechazo()]
                );
        });

export const aprobarDocumentosEpic = action$ =>
    action$.ofType(APROBAR_DOCUMENTOS)
        .mergeMap((action) => {
            return authenticatedAjax
                .post(
                    "aprobar-documento", {
                        dni: action.dni,
                        dniAprueba: action.dniAprueba,
                        tipoCliente: action.tipoCliente
                    },
                    {"Content-Type": "application/json"}
                )
                .map((response) =>
                    documentosAprobados(action.dni, action.tipoCliente)
                )
                .catch(response =>
                    [errorAprobandoDocumentos()]
                );
        });

export const anularDocumentosEpic = action$ =>
    action$.ofType(ANULAR_DOCUMENTOS)
        .mergeMap((action) => {

            return authenticatedAjax
                .post("anular-documento", {dni: action.dni}, {"Content-Type": "application/json"})
                .map((response) =>
                    documentosAnulados(action.dni)
                )
                .catch(response =>
                    [errorAnulandoDocumentos()]
                );
        });

export const rechazarDocumentosEpic = action$ =>
    action$.ofType(RECHAZAR_DOCUMENTOS)
        .mergeMap((action) => {

            return authenticatedAjax
                .post("rechazar-documento", {
                    dni: action.dni,
                    dniRechaza: action.dniRechaza,
                    tipoCliente: action.tipoCliente,
                    codigosRechazo: action.codigosRechazo
                }, {"Content-Type": "application/json"})
                .map((response) =>
                    documentosRechazados(action.dni, action.tipoCliente)
                )
                .catch(response =>
                    [errorRechazandoDocumentos()]
                );
        });

export const consultarAfiliacionEpic = action$ =>
    action$.ofType(CONSULTAR_AFILIACION)
        .mergeMap((action) => {
            var filter = action.filtro && action.filtro.dni ? `dni=${action.filtro.dni}` : "";

            filter += action.filtro && action.filtro.tipoCliente ?
                (filter ? `&tipoCliente=${action.filtro.tipoCliente}` : `tipoCliente=${action.filtro.tipoCliente}`)
                : "";

            filter += action.filtro.tamanoPagina ?
                (filter ? `&registrosPorPagina=${action.filtro.tamanoPagina}` :
                    `registrosPorPagina=${action.filtro.tamanoPagina}`)
                : "";

            filter += action.filtro.paginaActual ?
                (filter ? `&pagina=${(action.filtro.paginaActual + 1)}` :
                    `pagina=${(action.filtro.paginaActual + 1)}`)
                : "";

            const url = `afiliaciones?${filter}`;

            return authenticatedAjax
                .get(
                    url
                )
                .map((response) => {
                    const respuesta = JSON.parse(response.response);
                    return afiliacionConsultada(parseAfiliaciones(respuesta.respuesta),respuesta.paginas);
                })
                .catch(response =>
                    [errorConsultandoAfiliacion()]
                );
        });

export const recibirDocumentosEpic = action$ =>
    action$.ofType(RECIBIR_DOCUMENTOS)
        .mergeMap((action) => {

            return authenticatedAjax
                .post("recibir-documentos", {
                    dni: action.dni,
                    dniRecibe: action.dniRecibe,
                    tipoCliente: action.tipoCliente.id,
                    oficina: action.oficina
                }, {"Content-Type": "application/json"})
                .map((response) =>
                    documentosRecibidos()
                )
                .catch(response =>
                    [errorRecibiendoDocumentos()]
                );
        });

export const actualizarTipoDocumentalEpic = action$ =>
    action$.ofType(ACTUALIZAR_TIPO_DOCUMENTAL)
        .mergeMap((action) => {
            return authenticatedAjax
                .post("actualizar-tipodocumental", {
                    dni: action.dni,
                    tipoDocumental: action.tipoDocumental,
                    id: action.id,
                    titulo: action.titulo
                }, {"Content-Type": "application/json"})
                .map((response) =>
                    tipoDocumentalActualizado()
                )
                .catch(response =>
                    [errorActualizandoTipoDocumental()]
                );
        });

export const consultarDocumentosComercialEpic = action$ =>
    action$.ofType(CONSULTAR_DOCUMENTOS_COMERCIAL)
        .mergeMap((action) => {
            var filter = action.filtroDocumento && action.filtroDocumento.dni ? `dni=${action.filtroDocumento.dni}` : "";
            filter += action.filtroDocumento && action.filtroDocumento.fechaInicio ?
            (filter ? `&fechaInicio=${action.filtroDocumento.fechaInicio}` :
                    `fechaInicio=${action.filtroDocumento.fechaInicio}`)
                : ""; 
     
            filter += action.filtroDocumento && action.filtroDocumento.fechaFin ?
                (filter ? `&fechaFin=${action.filtroDocumento.fechaFin}` :
                    `fechaFin=${action.filtroDocumento.fechaFin}`)
                : ""; 
     
            filter += action.filtroDocumento && action.filtroDocumento.tipoCliente ? 
                (filter ? `&tipoCliente=${action.filtroDocumento.tipoCliente}` :
                    `tipoCliente=${action.filtroDocumento.tipoCliente}`)
                : "";
                
            filter += action.filtroDocumento.tamanoPagina ?
                (filter ? `&registrosPorPagina=${action.filtroDocumento.tamanoPagina}` :
                    `registrosPorPagina=${action.filtroDocumento.tamanoPagina}`)
                : "";
     
            filter += action.filtroDocumento.paginaActual ?
                (filter ? `&pagina=${(action.filtroDocumento.paginaActual + 1)}` :
                    `pagina=${(action.filtroDocumento.paginaActual + 1)}`)
                : "";
     
            filter += action.filtroDocumento.tipoTramite ?
                (filter ? `&tipoTramite=${(action.filtroDocumento.tipoTramite)}` :
                    `tipoTramite=${(action.filtroDocumento.tipoTramite)}`)
                : "";
    
            filter += action.filtroDocumento.canalComercial ?
                (filter ? `&canalComercial=${(action.filtroDocumento.canalComercial)}` :
                    `canalComercial=${(action.filtroDocumento.canalComercial)}`)
                : "";
                
            filter += action.filtroDocumento.poliza ?
                (filter ? `&poliza=${(action.filtroDocumento.poliza)}` :
                    `poliza=${(action.filtroDocumento.poliza)}`)
                : "";
     
            const url = `documentos-comercial?${filter}`;
     
            return authenticatedAjax
                .get(
                    url
                )
                .map((response) => {
                    const respuesta = JSON.parse(response.response);
                    return documentosConsultadosComercial(parseDocumentos(respuesta.respuesta),respuesta.paginas);
                })
                .catch(error => {
                    return [errorConsultandoDocumentosComercial()];
                }
                );
        });

export const aprobarDocumentosComercialEpic = action$ =>
    action$.ofType(APROBAR_DOCUMENTOS_COMERCIAL)
        .mergeMap((action) => {
            return authenticatedAjax
                .post(
                    "aprobar-documentos-comercial", {
                        dni: action.dni,
                        dniAprueba: action.dniAprueba,
                        tipoCliente: action.tipoCliente
                    },
                    {"Content-Type": "application/json"}
                )
                .map((response) =>
                    documentosComercialAprobados(action.dni, action.tipoCliente)
                )
                .catch(response =>
                    [errorAprobandoDocumentosComercial()]
                );
        }); 

export const reportarDocumentosComercialEpic = action$ => 
    action$.ofType(REPORTAR_DOCUMENTOS_COMERCIAL)
        .mergeMap((action) => {
            return authenticatedAjax
                .post(
                    "reportar-documentos-comercial", {
                        dni: action.dni,
                        dniRechaza: action.dniRechaza,
                        tipoCliente: action.tipoCliente,
                        codigosRechazo: action.codigosRechazo
                    },
                    {"Content-Type": "application/json"}
                )
                .map((response) => 
                    documentosComercialReportados(action.dni, action.tipoCliente)
                )
                .catch(response =>
                    [errorReportandoDocumentosComercial()]
                );
        });

/*
* Reducer
* https://redux.js.org/docs/basics/Reducers.html
 */
export const documentosReducer = (state = {
    estado: REQUEST.NONE,
    estadoComercial: REQUEST.NONE,
    estadoP8: REQUEST.NONE,
    estadoAction: REQUEST.NONE,
    estadoRecepcion: REQUEST.NONE,
    estadoTipoDocumental: REQUEST.NONE,
    mensajeAction: undefined,
    mensajeUsuario: false,
    mensajeUsuarioRecepcion: false,
    documentos: [],
    documentosComercial: [],
    documentosP8: [],
    motivosRechazo: [],
    afiliaciones: [],
    tamanoPagina: 10,
    paginaActual: 0,
    asignado: undefined,
    nombreAsesor: ""
}, action: AnyAction) => {
    switch (action.type) {

        case LIMPIAR_MENSAJES_DOCUMENTOS:
            return {...state, mensajeAction: undefined, mensajeUsuario: false, estadoAction: REQUEST.NONE, estadoTipoDocumental: REQUEST.NONE};
    
    // Reducers for get documents for approval in direct affiliation    
        case CONSULTAR_DOCUMENTOS:
            return {...state, documentos: [], 
                estado: REQUEST.PENDING, 
                estadoReintento: REQUEST.NONE, 
                paginaActual: action.filtroDocumento.paginaActual,
                tamanoPagina: action.filtroDocumento.tamanoPagina,
                mensajeUsuario: false 
            };
        case DOCUMENTOS_CONSULTADOS:
            return {...state, documentos: action.documentos, estado: REQUEST.SUCCESS, paginas : action.paginas};
        case ERROR_CONSULTANDO_DOCUMENTOS:
            return {...state, estado: REQUEST.ERROR, documentos: []};

    // Reducers for actions get documents P8
        case CONSULTAR_DOCUMENTO_P8:
            return {
                ...state,
                estadoP8: REQUEST.PENDING,
                estadoAction: REQUEST.NONE,
                mensajeUsuario: false
            };
        case DOCUMENTO_P8_CONSULTADO:
            return {
                ...state,
                documentosP8: parseDocumentosP8(action.documentoP8, state.documentosP8),
                estadoP8: REQUEST.SUCCESS
            };
        case ERROR_CONSULTANDO_DOCUMENTO_P8:
            return {...state, estadoP8: REQUEST.ERROR};

    // Reducers for actions actions cancel in reception documents
        case MOTIVOS_RECHAZO_CONSULTADOS:
            return {...state, motivosRechazo: action.motivosRechazo};

    // Reducers for actions actions cancel in reception documents
        case ANULAR_DOCUMENTOS:
            return {...state, estadoAction: REQUEST.PENDING, mensajeAction: "Anulando", mensajeUsuario: false};
        case DOCUMENTOS_ANULADOS:
            return {
                ...state,
                estadoAction: REQUEST.SUCCESS,
                documentos: removerDocumento(action.dni, action.tipoCliente, state.documentos)
            };
        case ERROR_ANULANDO_DOCUMENTOS:
            return {...state, estadoAction: REQUEST.ERROR};

    // Reducers for actions in modal for reject documents
        case RECHAZAR_DOCUMENTOS:
            return {
                ...state, 
                estadoAction: REQUEST.PENDING,
                mensajeAction: "Rechazando",
                mensajeUsuario: false, 
                asignado: undefined
                };
        case DOCUMENTOS_RECHAZADOS:
            return {
                ...state,
                estadoAction: REQUEST.SUCCESS,
                documentos: removerDocumento(action.dni, action.tipoCliente, state.documentos),
                mensajeUsuario: {
                    type: "success",
                    text: "Los documentos se han rechazado exitosamente"
                }
            };
        case ERROR_RECHAZANDO_DOCUMENTOS:
            return {
                ...state, estadoAction: REQUEST.ERROR, mensajeUsuario: {
                    type: "danger",
                    text: "Se ha presentado un error rechazando los documentos, por favor intente nuevamente."
                }
            };

    // Reducers for actions in modal validation assignation
        case VALIDAR_ASIGNACION: 
            return {
                ...state,
                estadoAction: REQUEST.PENDING,
                asignado: false,
                nombreAsesor : undefined
            };
        case VALIDACION_FINALIZADA:
            {
                console.log("accion ",action);
                return {
                ...state,
                estadoAction: REQUEST.SUCCESS,
                asignado: {dni: action.dni,asignado: action.asignado, tipoCliente: action.tipoCliente},
                nombreAsesor : action.nombreAsesor ? action.nombreAsesor : undefined
            };
        }

    // Reducers for actions in modal affiliations approve
        case APROBAR_DOCUMENTOS:
            return {...state, 
                estadoAction: REQUEST.PENDING, 
                mensajeAction: "Aprobando", 
                mensajeUsuario: false,
                asignado: undefined
            };
        case DOCUMENTOS_APROBADOS:
            return {
                ...state,
                estadoAction: REQUEST.SUCCESS,
                mensajeUsuario: {
                    type: "success", text: "Se está ejecutando la creación de la póliza, la " +
                    "información sobre la misma la encontrará en la bandeja de tareas"
                },
                documentos: removerDocumento(action.dni, action.tipoCliente, state.documentos)
            };
        case ERROR_APROBANDO_DOCUMENTOS:
            return {
                ...state, estadoAction: REQUEST.ERROR, mensajeUsuario: {
                    type: "danger",
                    text: "Se ha presentado un error aprobando los documentos, por favor intente nuevamente."
                }
            };

    // Reducers for actions in reception documents
        case CONSULTAR_AFILIACION:
            return {
                ...state,
                estadoRecepcion: REQUEST.PENDING,
                mensajeUsuarioRecepcion: false,
                paginaActual: action.filtro.paginaActual,
                tamanoPagina: action.filtro.tamanoPagina
            };
        case AFILIACION_CONSULTADA:
            return {
                ...state,
                estadoRecepcion: REQUEST.SUCCESS,
                afiliaciones: action.afiliaciones,
                paginas : action.paginas
            };
        case ERROR_CONSULTANDO_AFILIACION:
            return {
                ...state,
                estadoRecepcion: REQUEST.ERROR
            };

    // Reducers for actions in modal reception documents
        case RECIBIR_DOCUMENTOS:
            return {...state, estadoRecepcion: REQUEST.PENDING, mensajeUsuarioRecepcion: false};
        case DOCUMENTOS_RECIBIDOS:
            return {
                ...state, estadoRecepcion: REQUEST.SUCCESS, afiliaciones: [], mensajeUsuarioRecepcion: {
                    type: "success", text: "La recepción se ha guardado exitosamente."
                }
            };
        case ERROR_RECIBIENDO_DOCUMENTOS:
            return {...state, estadoRecepcion: REQUEST.ERROR};

    // Reducers for actions in change documental type
        case ACTUALIZAR_TIPO_DOCUMENTAL:
            return {...state, estadoTipoDocumental: REQUEST.PENDING};
        case TIPO_DOCUMENTAL_ACTUALIZADO:
            return {...state, estadoTipoDocumental: REQUEST.SUCCESS};
        case ERROR_ACTUALIZANDO_TIPO_DOCUMENTAL:
            return {...state, estadoTipoDocumental: REQUEST.ERROR};

    // Reducers for actions in Commercial Channel
        case CONSULTAR_DOCUMENTOS_COMERCIAL:
            return {...state, documentosComercial: [], 
                estadoComercial: REQUEST.PENDING, 
                estadoReintento: REQUEST.NONE, 
                paginaActual: action.filtroDocumento.paginaActual,
                tamanoPagina: action.filtroDocumento.tamanoPagina,
                mensajeUsuario: false 
            }; 
        case DOCUMENTOS_CONSULTADOS_COMERCIAL:
            return {...state, documentosComercial: action.documentosComercial, estadoComercial: REQUEST.SUCCESS, paginas : action.paginas};
        case ERROR_CONSULTANDO_DOCUMENTOS_COMERCIAL:
            return {...state, estadoComercial: REQUEST.ERROR, documentosComercial: []};

    // Reducers for actions in modal for approve documents commercials
        case APROBAR_DOCUMENTOS_COMERCIAL:
            return {
                ...state,
                estadoAction: REQUEST.PENDING,
                mensajeAction: "Aprobando los documentos ingresados por canal comercial",
                mensajeUsuario: false,
                asignado: undefined
            };
        case DOCUMENTOS_COMERCIAL_APROBADOS:
            return {
                ...state,
                estadoAction: REQUEST.SUCCESS,
                documentosComercial: removerDocumento(action.dni, action.tipoCliente, state.documentosComercial),
                mensajeUsuario: {
                    type: "success",
                    text: "Se han aprobado los documentos"
                }
            };
        case ERROR_APROBANDO_DOCUMENTOS_COMERCIAL:
            return {
                ...state, estadoAction: REQUEST.ERROR, mensajeUsuario: {
                    type: "danger",
                    text: "Se ha presentado un error aprobando los documentos, por favor intente nuevamente."
                }
            };

    // Reducers for actions in modal for report documments commercials
        case REPORTAR_DOCUMENTOS_COMERCIAL:
            return {
                ...state,
                estadoAction: REQUEST.PENDING,
                mensajeAction: "Reportando inconsistencias en los documentos",
                mensajeUsuario: false,
                asignado: undefined
            };
        case DOCUMENTOS_COMERCIAL_REPORTADOS:
            return {
                ...state,
                estadoAction: REQUEST.SUCCESS,
                documentosComercial: removerDocumento(action.dni, action.tipoCliente, state.documentosComercial),
                mensajeUsuario: {
                    type: "success",
                    text: "Se ha reportado la inconsistencia de los documentos"
                }
            };
        case ERROR_REPORTANDO_DOCUMENTOS_COMERCIAL:
            return {
                ...state, estadoAction: REQUEST.ERROR, mensajeUsuario: {
                    type: "danger",
                    text: "Se ha presentado un error reportando la inconsistencia en los documentos, por favor intente nuevamente."
                }
            };
        default:
            return state;
    }
};

// Parser functions
const parseDocumentosP8 =
    (documentoP8: DocumentoP8, documentosP8: Array<DocumentoP8>): Array<DocumentoP8> => {
        let filtrado = documentosP8.slice();

        const documento = filtrado.find(doc => doc.idDocument === documentoP8.idDocument);
        filtrado.splice(filtrado.lastIndexOf(documento), 1);

        return filtrado.concat([documentoP8]);
    };

const parseDocumentos = (response: Array<any>): Array<Documento> => {
    console.log("resultado de consulta", response);
    const documentos = response.map(d => {
        return {
            afiliado: d.afiliado,
            estado: d.estado,
            fechaRadicacion: moment(d.fechaRadicacion).format(DATE_FORMAT_WITH_HOUR),
            documentos: d.documentos,
            tipoCliente: obtenerTipoCliente(d.tipoAfiliado),
            fechaAsignacion: d.fechaAsignacion ? moment(d.fechaAsignacion).format(DATE_FORMAT_WITH_HOUR) : "",
            tipoTramite: d.tipoTramite,
            usuarioAprueba: d.usuarioAprueba,
            poliza: d.poliza ? d.poliza : "",
            fechaInicioCobertura:   d.fechaInicioCobertura ? d.fechaInicioCobertura : "",
            dniEmpleador: d.dniEmpleador ? d.dniEmpleador : "",
            observacion: d.observacion ? d.observacion : ""
        };
    });
    return documentos;
};

const parseAfiliaciones = (response: Array<any>): Array<Afiliacion> => {
    const afiliaciones = response.filter(a => a !== null).map(a => {
        return {
            afiliado: a.afiliado,
            tipoCliente: obtenerTipoCliente(a.tipoCliente),
            estado: a.estado ? a.estado : EstadoDocumento.pendiente
        };
    });
    return afiliaciones;
};

const parseMotivosRechazo = (response: Array<any>): Array<MotivoRechazo> => {
    const motivosRechazo = response.map(motivo => {
        return {
            codigo: motivo.codigo,
            descripcion: motivo.descripcion
        };
    });
    return motivosRechazo;
};

const removerDocumento = (dni, tipoCliente, documentos: Array<Documento>): Array<Documento> => {
    let filtrado = documentos.slice();

    filtrado.splice(
        filtrado.lastIndexOf(
            filtrado.filter(doc => doc.afiliado.identificacion === dni && doc.tipoCliente.id === tipoCliente)[0]
        )
        , 1);

    return filtrado;
};



// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/modulos/documentosReducers.ts